import { Box, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

import { getDesignTokens } from '../core';
import TextField from '../text-field';

interface Props {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onSearchChange?: () => void;
  children?: React.ReactNode;
  className?: string;
}

const SearchAndFiltersBarImpl: React.FC<Props> = ({
  placeholder = 'Search...',
  value,
  onChange,
  onSearchChange,
  children,
  className,
}) => {
  const theme = useTheme();
  const t = getDesignTokens(
    theme.palette.mode as 'light' | 'dark',
    theme.accentPalette
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
    onSearchChange?.();
  };

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        mb: 2,
        '& .search-field': { flex: 1, minWidth: 200 },
        '& .filter-field': { minWidth: 150 },
        '& .MuiOutlinedInput-root': {
          backgroundColor: `${t.surface1} !important`,
          '&:hover': { backgroundColor: `${t.surface1} !important` },
          '& .MuiInputBase-input, & .MuiSelect-select': {
            color: t.textPrimary,
            '&::placeholder': { color: t.textPlaceholder, opacity: 1 },
          },
        },
      }}
    >
      <TextField
        className="search-field"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        variant="outlined"
        size="small"
      />
      {children}
    </Box>
  );
};

const SearchAndFiltersBar = styled(SearchAndFiltersBarImpl)({});

export default SearchAndFiltersBar;
